module.exports = {
    title: "AI Scholarship Plan",
    crud: {
        create: "Create AI Scholarship Plan",
        edit:   "Edit AI Scholarship Plan",
        view:   "View AI Scholarship Plan",
    },
    table: {
        title:          'Title',
        platform:       'Platform',
        userType:       'User Type',
        skuCodeAndroid: 'SKU Code Android',
        skuCodeIos:     'SKU Code IOS',
        credits:        'Credits',
        offerCredits:   'Offer Credits',
        isFree:         'Is Free',
        createdAt:      'Created At',
        action:         "Action",
    },
    form: {
        type:          "Type",
        skuCodeAndroid:'SKU Code Android',
        skuCodeIos:    'SKU Code IOS',
        title:         "Title",
        description:   "Description",
        platform:      "Platform",
        price:         "Price",
        offerPrice:    "Offer Price",
        country:       "Country",
        duration:      "Duration",
        durationValue: "Duration Value",
        credits:       'Credits',
        offerCredits:  'Offer Credits',
        isFree:        'Is Free?',
    },
    validation: {
        required: {
            title:            'Title is required',
            type:             'Type is required',
            skuCodeAndroid:   'Android SKU ID is required',
            skuCodeIos:       'IOS SKU ID is required',
            description:      'Description is required',
            platform:         'Platform is required',
            offerCredits:     'Offer Credits is required',
            durationValueMin: 'Duration Value must be greater than or equal to 1',
            durationValueMax: 'Duration Value must be less than or equal to ',
        }
    },
}